import React from 'react';


const Footer = () => {

  return (
    <footer>
      <div className="inwrap">
        <p>COPYRIGHT © AVEAPP. ALL RIGHTS RESERVED.</p>
      </div>
    </footer>
  )
}

export default Footer;